import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, useHistory } from "react-router-dom";
import {
  auth,
  registerWithEmailAndPassword,
  signInWithGoogle,
} from "../../firebase";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "./Account.scss";

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const history = useHistory();
  const register = () => {
    // if (!name) alert("Please enter name");
    registerWithEmailAndPassword(name, email, password);
  };
  useEffect(() => {
    if (loading) return;
    if (user) history.replace("/dashboard");
  }, [user, loading]);
  return (
    <AnimationOnScroll animateIn="animate__fadeIn" delay={100}>
      <div className="container">
      <div className="row">
        <div className="col-lg-12 col-sm-12">
        <h2>Register</h2>
        <div className=" col-6 offset-3">
        <small className="">You are about to register for Llama - this will allow Lla.ma to notify you via email of updates to the Llama Token, including the start of the ICO and other important news about Llama.</small>
        </div>
      </div></div>
      </div>
    <div className="register">
      
      <div className="register__container">
        <h5>Llama - Register</h5>
        <input
          type="text"
          className="register__textBox"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Full Name"
        />
        <input
          type="text"
          className="register__textBox"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail Address"
        />
        <input
          type="password"
          className="register__textBox"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        <button className="register__btn" onClick={register}>
          Register
        </button>
        <button
          className="register__btn register__google"
          onClick={signInWithGoogle}
        >
          Register with Google
        </button>
        <div>
          Already have an account? <Link to="/login">Login</Link> now.
        </div>
      </div>
    </div>
    </AnimationOnScroll>
  );
}
export default Register;